import { NodeViewWrapper } from '@tiptap/react';
import React, { useCallback, useEffect, useRef } from 'react';
import cn from 'classnames';
import { getPresetId } from '../../../components/utils/tiptap';
import DaGallery from './DaGallery';
import { EXTENSION_TYPE_NAME } from '../constants';
import viewerStyles from '../Viewer/Viewer.scss';
const DeviationNodeView = (props)=>{
    const Renderer = props.editor.extensionStorage['da-ext-renderers'].gallery;
    const { editor, updateAttributes, extension, node } = props;
    const { options } = extension;
    const attrs = node.attrs;
    const editorDomRef = useRef(undefined);
    useEffect(()=>{
        editorDomRef.current = editor.view.dom;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onResizeEnd = useCallback((nextWidth)=>{
        updateAttributes({
            width: nextWidth
        });
    }, [
        updateAttributes
    ]);
    const nodeKey = `gallery-${!attrs.width ? 'default' : 'custom'}`;
    return /*#__PURE__*/ React.createElement(NodeViewWrapper, {
        key: nodeKey,
        "data-drag-handle": "true",
        className: cn('draggable-atomic', viewerStyles['gallery-container'], viewerStyles[attrs.alignment], options.smallMedia && viewerStyles['small-media'], viewerStyles[`preset-${getPresetId(editor)}`]),
        "data-da-type": EXTENSION_TYPE_NAME
    }, /*#__PURE__*/ React.createElement(DaGallery, {
        Renderer: Renderer,
        onResizeEnd: onResizeEnd,
        extOptions: options,
        defaultWidth: options.defaultWidth,
        editorDomRef: editorDomRef,
        deviations: attrs.deviations,
        linkOverrides: attrs.linkOverrides,
        attrWidth: attrs.width,
        gridItemHeight: attrs.gridItemHeight,
        gridItemWidth: attrs.gridItemWidth,
        itemCropping: attrs.itemCropping,
        layout: attrs.layout,
        layoutRowAlignment: attrs.layoutRowAlignment,
        layoutSpacing: attrs.layoutSpacing,
        torpedoRowHeight: attrs.torpedoRowHeight,
        alignment: attrs.alignment
    }));
};
DeviationNodeView.displayName = 'DeviationNodeView';
export default DeviationNodeView;

//# sourceMappingURL=GalleryNodeView.js.map